import { render, staticRenderFns } from "./luo.vue?vue&type=template&id=bf673b68"
import script from "./luo.vue?vue&type=script&lang=js"
export * from "./luo.vue?vue&type=script&lang=js"
import style0 from "./luo.vue?vue&type=style&index=0&id=bf673b68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports